import { useQuery } from "@tanstack/react-query";
import {
  fetchManageViewRoles,
  FetchManageViewRolesParams,
  FetchManageViewRolesResponse
} from "PFCore/services/roles";
import { QueryOptions } from "PFTypes/request_options";

import { rolesKeys } from "./query_keys";

export const useManageViewRoles = (
  params: FetchManageViewRolesParams,
  options: QueryOptions<FetchManageViewRolesResponse> = {}
) =>
  useQuery<FetchManageViewRolesResponse>({
    queryKey: rolesKeys.manageView(params),
    queryFn: () => fetchManageViewRoles(params),
    ...options
  });
